import { useQuery } from "@tanstack/react-query";

import { IUniversitySort } from "../models";
import { getUniversitySort } from "../queries";
import { universitiesConst } from "..";

export const useUniversitySort = (univerId?: string | string[]) => {
  const { data: sortUniversity, ...args } = useQuery<IUniversitySort[]>({
    queryKey: [universitiesConst.queryKeys.UNIVERSITIES_SORT, univerId],
    queryFn: getUniversitySort(univerId),
    enabled: !!univerId,
  });

  return { sortUniversity, ...args };
};

